const maxPageSize = 1000

export default maxPageSize
